import React from 'react';
import { Helmet } from 'react-helmet';
// Data for the blog posts
const blogPosts = [
  {
    id: 1,
    imgSrc: '/images/services/1.jpg',
    date: { day: '14', month: 'June' },
    author: 'Mike Hardson',
    title: 'Temple Tours and Pilgrimages',
    link: 'Discover spiritual bliss with AB Ghule Cabs, offering reliable and comfortable rides to sacred temples and pilgrimage destinations.',
  },
  {
    id: 2,
    imgSrc: 'images/services/2.jpg',
    date: { day: '18', month: 'July' },
    author: 'Devid Culun',
    title: 'Airport Pickup & Drop',
    link: 'Enjoy seamless airport pickup and drop services with AB Ghule Cabs, ensuring timely, comfortable, and hassle-free travel to or from the airport.',
  },
  {
    id: 3,
    imgSrc: 'images/services/3.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'Kevin Smith',
    title: 'Outstation Cab Service',
    link: 'Travel comfortably with AB Ghule Cabs outstation cab service, offering reliable and affordable rides to your favorite destinations.',
  },
  {
    id: 4,
    imgSrc: 'images/services/4.jpg',
    date: { day: '14', month: 'June' },
    author: 'Mike Hardson',
    title: 'Pune Cab Service',
    link: 'Experience reliable and affordable Pune cab services with AB Ghule Cabs, offering comfortable rides for local and outstation travel.',
  },
  {
    id: 5,
    imgSrc: 'images/services/5.jpg',
    date: { day: '18', month: 'July' },
    author: 'Devid Culun',
    title: 'Best Cab Service in Pune',
    link: 'Ride with AB Ghule Cabs, the best cab service in Pune, offering safe, reliable, and comfortable travel for all your journey needs.',
  },
  {
    id: 6,
    imgSrc: 'images/services/6.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'Kevin Smith',
    title: 'Corporate Cab Service in Pune',
    link: 'AB Ghule Cabs offers professional and reliable corporate cab services in Pune, ensuring timely and comfortable travel for business needs.',
  },
  {
    id: 6,
    imgSrc: '/images/our-fleet/5.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'Kevin Smith',
    title: 'Local Cab Service',
    link: 'Looking for a reliable and comfortable cab service for your daily travel needs? AB Ghule Cabs offers top-notch local cab services with well-maintained vehicles and professional drivers to ensure a smooth and hassle-free ride.',
  },
  {
    id: 6,
    imgSrc: 'images/Intercity.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'Kevin Smith',
    title: 'Intercity Cab Service',
    link: 'Planning a trip to another city? Whether it is a business meeting, family vacation, or a quick getaway, AB Ghule Cabs offers safe, comfortable, and affordable intercity cab services. With our experienced drivers and well-maintained vehicles, you can relax and enjoy your journey, no matter the distance.',
  },
  {
    id: 6,
    imgSrc: 'images/party.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'Kevin Smith',
    title: 'Cabs for Party & Events',
    link: 'Planning a special event or party? Whether it is a birthday bash, wedding celebration, or a corporate event, AB Ghule Cabs offers reliable and stylish transportation to make your occasion even more memorable. Our fleet of luxurious vehicles and professional drivers ensure you arrive in comfort, on time, and in style.',
  },
];

const Services = () => {
  return (


<div>
<Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable</title>
  <meta name="description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable" />
  <meta property="og:description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Mumbai Cabs",
        description: "Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "priceRange": "₹1500 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1500"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sneha Kulkarni"
            },
            "datePublished": "2024-12-22",
            "reviewBody": "Seamless booking process and the ride was very comfortable. Highly recommend AB Ghule Cabs for Pune to Mumbai trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vishal Sharma"
            },
            "datePublished": "2024-12-18",
            "reviewBody": "Great service at an affordable price. The driver was professional and punctual."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-mumbai-cabs"
        },
        "keywords": "Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way"
      }
    `}
  </script>
</Helmet>

    
<section id="about" className="jarallax text-light">
    <div className="center-y relative text-center">
        <div className="container">
            <div className="row">
                <div className="col-md-12 text-center">
                    <h1 className='text-white'>Services</h1>
                </div>
                <div className="clearfix"></div>
            </div>
        </div>
    </div>
</section>
    <div className="section-full p-t150 p-b150 site-bg-white twm-blog-grid-2-section-wrap pt-5">
      <div className="container">
        <div className="section-content">
         
          <div className="masonry-wrap row">
          
            {blogPosts.map((post) => (
              <div
                key={post.id}
                className="masonry-item col-xl-4 col-lg-6 col-md-6 m-b30 wow fadeInDown"
                data-wow-delay="0.2"
              >
                <div className="twm-blog-grid-2">
                  <div className="wt-post-media">
                    <a>
                      <img src={post.imgSrc} alt={post.title} />
                    </a>
                  </div>
                  <div className="twm-post-info-wrap">
                    <div className="post-date-wrap">
                     
                    </div>
                    <div className="twm-post-info">
                     
                      <h3 className="post-title">
                        <a className='darkcolorr'>{post.title}</a>
                      </h3>
                      <p>{post.link}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

         
        </div>
      </div>
    </div>
</div>
  );
};

export default Services;
